import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { conversationalReplyRouting } from "./constants";
import type { ConversationalReplyRoutingResult } from "./types";
import { isConversationalReplyRoutingResult } from "./validators";

/** What happens to a reply on one SMS or WhatsApp subscription group, for the message composers. */
export const getConversationalReplyRouting = reactQueryFetcherAdapter(
  conversationalReplyRouting,
  (
    signal: AbortSignal,
    appGroupId: string,
    subscriptionGroupId: string
  ): Promise<ConversationalReplyRoutingResult> => {
    return fetch(
      `/${appGroupId}/conversational/reply_routing`,
      "GET",
      { subscription_group_id: subscriptionGroupId },
      { signal }
    );
  },
  isConversationalReplyRoutingResult
);
